var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"base-card shadow"},[_c('v-card-title',{staticClass:"headline accent--text pb-4"},[_vm._v(" Комментарий при отклонении работы ")]),_c('v-card-text',[_c('CardTextAreaRow',{attrs:{"label":"Комментарий","value":_vm.comment,"readonly":true,"hide-border-bottom":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }